import { gql } from '@apollo/client';

export const DISABLE_EMAIL_NOTIFICATION_MUTATION = gql`
  mutation DisableEmailNotificationMutation(
    $ID: ID!
    $agentID: ID!
    $input: EmailNotificationInput!
  ) {
    disableEmailNotification(ID: $ID, agentID: $agentID, input: $input) {
      ID
      frequency
      name
    }
  }
`;
